import { useRequiredContext } from '#hooks/use-required-context/index.ts';
import { TicketsContext } from '#providers/tickets/Tickets.context.ts';
import type { TTicketsContextValue } from '#providers/tickets/Tickets.types.ts';

export const useTickets = (): TTicketsContextValue =>
  useRequiredContext(
    TicketsContext,
    'useTickets is only available inside a TicketsProvider',
  );
